import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home                       from "./pages/Home";
import About                      from "./pages/About";
import Services                   from "./pages/Services";
import BuildingConstruction       from "./pages/BuildingConstruction";
import HouseRenovation            from "./pages/HouseRenovation";
import ElectricalWiring           from "./pages/ElectricalWiring";
import LightingInstallation       from "./pages/LightingInstallation";
import CircuitDesign              from "./pages/CircuitDesign";
import PowerBackupSystems         from "./pages/PowerBackupSystems";
import SafetyInspectionCompliance from "./pages/SafetyInspectionCompliance";
import Projects                   from "./pages/Projects";
import Residential                from "./pages/Residential";
import Commercial                 from "./pages/Commercial";
import Industrial                 from "./pages/Industrial";
import Government                 from "./pages/Government";
import Contact                    from "./pages/Contact";      // if your contact page lives under /pages
import Products                   from "./pages/Products";
import SpecializedElectricalInstallations from "./pages/SpecializedElectricalInstallations";
import ShareExperience            from "./pages/ShareExperience";

function App() {
  return (
    <BrowserRouter>
      <Header />

      <Routes>
        {/* HOME & INFO */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />

        {/* SERVICES */}
        <Route path="/services"                                     element={<Services />} />
        <Route path="/services/building-construction"               element={<BuildingConstruction />} />
        <Route path="/services/house-renovation"                    element={<HouseRenovation />} />
        <Route path="/services/electrical-wiring"                   element={<ElectricalWiring />} />
        <Route path="/services/lighting-installation"               element={<LightingInstallation />} />
        <Route path="/services/circuit-design"                      element={<CircuitDesign />} />
        <Route path="/services/power-backup-systems"                element={<PowerBackupSystems />} />
        <Route path="/services/safety-inspection-compliance"        element={<SafetyInspectionCompliance />} />
        <Route path="/services/specialized-electrical-installations" element={<SpecializedElectricalInstallations />} />

        {/* PROJECTS */}
        <Route path="/projects"            element={<Projects />} />
        <Route path="/projects/residential" element={<Residential />} />
        <Route path="/projects/commercial"  element={<Commercial />} />
        <Route path="/projects/industrial"  element={<Industrial />} />
        <Route path="/projects/government"  element={<Government />} />

        {/* PRODUCTS */}
        <Route path="/products" element={<Products />} />

        {/* CONTACT */}
        <Route path="/contact" element={<Contact />} />

        {/* TESTIMONIALS — the link you send clients */}
        <Route path="/share-your-experience" element={<ShareExperience />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
